import { useMemo } from "react"
import { getChangedEntries, getUnchangedEntries } from "../utils"
import { ResolvedFleetEntry } from "../../../api/fleet"

type EditConfirmationHook = {
  changedEntries: ResolvedFleetEntry[]
  unchangedEntries: ResolvedFleetEntry[]
}

export const useChangedAndUnchangedEntries = (
  initialEntries: ReadonlyArray<ResolvedFleetEntry>,
  currentEntries: ReadonlyArray<ResolvedFleetEntry>,
  expectedChangeVrns?: string[]
): EditConfirmationHook => {
  const changedEntries = useMemo(
    () => getChangedEntries(initialEntries, currentEntries),
    [initialEntries, currentEntries]
  )

  const unchangedEntries = useMemo(
    () => getUnchangedEntries(changedEntries, currentEntries, expectedChangeVrns),
    [changedEntries, currentEntries, expectedChangeVrns]
  )

  return {
    changedEntries,
    unchangedEntries,
  }
}
